import { useMemo } from 'react';
import { useLocation } from 'umi';
import { getValidTopChartName } from '@/pages/intelligence/_config/storeRank/utils';

export default function useInitialTopChartsName(sources: string[], sourceKey?: string) {
  const sourceKeyTmp = sourceKey || 'source';

  const location = useLocation();

  const topChartsName = useMemo(() => {
    const urlSearchParams = new URLSearchParams(location.search);
    const urlTopChartsName = decodeURIComponent(urlSearchParams.get(sourceKeyTmp) || '');
    return getValidTopChartName(urlTopChartsName, sources);
  }, [location?.search]);

  return topChartsName;
}
